import { useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    Stack,
    TextField,
} from '@mui/material';
import useErrors from '../../../../hooks/useErrors';
import server from '../../../../services/server';
import { EUROBEM_ADMIN_TEAMS } from '../adminTeams';

const inviteSchema = yup.object().shape({
    email: yup.string().email('Informe um e-mail válido').required('Informe o e-mail'),
    team: yup.string().oneOf(EUROBEM_ADMIN_TEAMS.map(t => t.value)).required('Selecione o cargo'),
});

export default function DialogInviteUser({ open, onClose, onSuccess }) {
    const { setErrors, enqueueSnackbar } = useErrors();
    const formik = useFormik({
        enableReinitialize: true,
        validationSchema: inviteSchema,
        initialValues: { email: '', team: 'member' },
        onSubmit: async values => {
            try {
                await server.post('users/invites', {
                    email: values.email.trim(),
                    team: values.team,
                });
                enqueueSnackbar('Convite enviado.', { variant: 'success' });
                await onSuccess();
                onClose();
            } catch (error) {
                setErrors(error);
            }
        },
    });

    useEffect(() => {
        if (open) formik.resetForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Convidar usuário</DialogTitle>
            <DialogContent dividers>
                <Stack spacing={2} pt={1} component="form" onSubmit={formik.handleSubmit}>
                    <TextField
                        label="E-mail"
                        name="email"
                        type="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        fullWidth
                        error={formik.touched.email && Boolean(formik.errors.email)}
                        helperText={
                            (formik.touched.email && formik.errors.email) ||
                            'Enviamos um link com validade limitada. O convidado cria a conta ou entra para aceitar.'
                        }
                    />
                    <TextField
                        select
                        label="Cargo"
                        name="team"
                        value={formik.values.team}
                        onChange={formik.handleChange}
                        fullWidth
                        error={formik.touched.team && Boolean(formik.errors.team)}
                        helperText={formik.touched.team && formik.errors.team}
                    >
                        {EUROBEM_ADMIN_TEAMS.map(item => (
                            <MenuItem key={item.value} value={item.value}>
                                {item.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button
                    variant="contained"
                    onClick={formik.handleSubmit}
                    disabled={formik.isSubmitting}
                >
                    Enviar convite
                </Button>
            </DialogActions>
        </Dialog>
    );
}
